/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Grid, Typography2 } from '@coursera/cds-core';
import { CertificateIcon } from '@coursera/cds-icons';

import {
  getForCreditFilterLabelText,
  getShouldShowForCreditFilter,
} from 'bundles/search-common/utils/forCreditExperimentUtils';

type Props = {
  isCreditEligible?: boolean;
};

const Styles = {
  iconContainer: css`
    margin-left: 0.25rem;
  `,
};

const CreditEligibleBadge = ({ isCreditEligible }: Props) => {
  if (!isCreditEligible || !getShouldShowForCreditFilter()) return null;

  return (
    <Grid container data-e2e="rc-CreditEligibleBadge">
      <Grid item>
        <CertificateIcon size="medium" color="support" />
      </Grid>
      <Grid item css={Styles.iconContainer}>
        <Typography2 component="p" variant="bodySecondary" color="supportText" data-e2e="creditEligibleText">
          {getForCreditFilterLabelText()}
        </Typography2>
      </Grid>
    </Grid>
  );
};

export default CreditEligibleBadge;
